import React from 'react'
import { graphql } from 'gatsby'
import { Background, Container, Section } from '../../components/page'
import { HeroText, HeroTitle } from '../../components/hero'
import { Image } from '../../components/image'

import * as styles from './ambassadors-hero.module.scss'

export type AmbassadorsHeroProps = Queries.AmbassadorsHeroFragment

export const AmbassadorsHero = ({
  title,
  text,
  image,
}: AmbassadorsHeroProps) => {
  return (
    <Section className={styles.section} variant="hero">
      <Container className={styles.container}>
        <div className={styles.text}>
          <HeroTitle color="light">{title}</HeroTitle>
          <HeroText color="light">{text?.text}</HeroText>
        </div>
        <div className={styles.image}>
          <Image image={image} alt={image?.title!} loading="eager" />
        </div>
      </Container>
      <Background className={styles.background} variant="hero" />
    </Section>
  )
}

export const AmbassadorsHeroFragments = graphql`
  fragment AmbassadorsHeroImage on ContentfulAsset {
    __typename
    id
    title
    gatsbyImageData
  }
  fragment AmbassadorsHero on ContentfulAmbassadorsHero {
    __typename
    id
    title
    text {
      text
    }
    image {
      ...AmbassadorsHeroImage
    }
  }
`
